import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCurrentLanguage } from "@/store/data/global";
import "./index.less";

const STORAGE_KEY = "kigen_cookie_consent";

const copy = {
  EN: {
    title: "Cookie Notice",
    body: "We use cookies to ensure site functionality and improve your experience. Analytics cookies are used only with your consent.",
    accept: "Accept",
    decline: "Decline",
    policy: "Privacy Policy",
  },
  JA: {
    title: "クッキーについて",
    body: "当サイトでは、サイトの動作確保と体験向上のためにクッキーを使用します。分析用クッキーは、お客様の同意がある場合にのみ使用します。",
    accept: "同意する",
    decline: "拒否する",
    policy: "プライバシーポリシー",
  },
};

const CookieConsent = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const text = copy[currentLanguage] || copy.JA;

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        const timer = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(timer);
      }
    } catch {
      setVisible(true);
    }
    return undefined;
  }, []);

  const dismiss = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // ignore storage errors
    }
    setLeaving(true);
    setTimeout(() => setVisible(false), 320);
  };

  if (!visible) return null;

  return (
    <div
      className={`cookie-consent${leaving ? " is-leaving" : ""}`}
      role="dialog"
      aria-live="polite"
      aria-label={text.title}
    >
      <div className="cookie-consent__inner">
        <div className="cookie-consent__text">
          <div className="cookie-consent__title">{text.title}</div>
          <p className="cookie-consent__body">
            {text.body}{" "}
            <Link to="/privacy-policy" className="cookie-consent__link">
              {text.policy}
            </Link>
          </p>
        </div>
        <div className="cookie-consent__actions">
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--ghost"
            onClick={() => dismiss("declined")}
          >
            {text.decline}
          </button>
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--primary"
            onClick={() => dismiss("accepted")}
          >
            {text.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
